var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgl-permalink"},[(_vm.slug !== '')?_c('div',[_vm._v("\n    "+_vm._s(_vm.permalink)+"\n  ")]):_vm._e(),(_vm.slug === '')?_c('small',[_vm._v("\n    Not specified yet.\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }